import { match } from 'ts-pattern'

import { Data } from '@blade/std-lib'
export type OrderType = 'limit' | 'market'
export type SwapDirection = 'buy' | 'sell'

export const matchOrderType = Data.matchString<OrderType>()
export const matchSwapDirection = Data.matchString<SwapDirection>()

export type Type = `${OrderType}-${SwapDirection}`

export type ExtendedTxType =
  | Type
  | SwapDirection
  | 'poolInit'
  | 'liquidityAdd'
  | 'liquidityRemove'
  | 'poolMigrate'
  | 'quoteBurn'
  | 'lpBurn'

export const isLimit = (type: Type): boolean => {
  return type === 'limit-buy' || type === 'limit-sell'
}

export const isMarket = (type: Type): boolean => {
  return type === 'market-buy' || type === 'market-sell'
}

export const isBuy = (type: Type): boolean => {
  return type === 'limit-buy' || type === 'market-buy'
}

export const isSell = (type: Type): boolean => {
  return type === 'limit-sell' || type === 'market-sell'
}

export const orderTypeOf = (type: Type): OrderType => {
  return isLimit(type) ? 'limit' : 'market'
}

export const toMarketType = (type: SwapDirection): Type => {
  return match(type)
    .with('buy', () => 'market-buy' as const)
    .with('sell', () => 'market-sell' as const)
    .exhaustive()
}
